// Custom hook for managing vSphere credentials editing
import { useState, useCallback } from 'react';

export const useVSphereCredentials = () => {
    const [canEdit, setCanEdit] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
    });

    const enableEdit = useCallback(() => {
        setCanEdit(true);
    }, []);

    const toggleEdit = useCallback(() => {
        setShowEdit((prev) => !prev);
    }, []);

    const updateCredentials = useCallback((field, value) => {
        setCredentials((prev) => ({
            ...prev,
            [field]: value,
        }));
    }, []);

    const reset = useCallback(() => {
        setShowEdit(false);
        setCredentials({ username: '', password: '' });
    }, []);

    return {
        canEdit,
        showEdit,
        credentials,
        enableEdit,
        toggleEdit,
        updateCredentials,
        reset,
    };
};
